module.exports = __webpack_public_path__ + "static/media/morango.8860f7f0.png";